import { StyleSheet, TouchableOpacity, View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Text } from '../Text';
import { DotIcon } from './DotIcon';
import { spacing } from '../../theme';
import { withTranslation } from '../../locales/hoc';

const StepperComponent = ({ steps, activeStep, showTextProgress = false, ...viewProps }: Props) => {
	const { t } = useTranslation();

	return (
		<View {...viewProps}>
			<View style={styles.dots}>
				{Array(steps)
					.fill(null)
					.map((_, index) => (
						<TouchableOpacity key={index} style={styles.dot}>
							<DotIcon active={activeStep === index} completed={activeStep > index} />
						</TouchableOpacity>
					))}
			</View>
			{showTextProgress && (
				<Text category="label" style={styles.text}>
					{t('stepper.steps-of-total', { completed: activeStep + 1, total: steps })}
				</Text>
			)}
		</View>
	);
};

export const Stepper = withTranslation(StepperComponent);
interface Props extends ViewProps {
	steps: number;
	activeStep: number;
	showTextProgress?: boolean;
}

const styles = StyleSheet.create({
	dots: {
		flexDirection: 'row',
	},
	dot: {
		paddingHorizontal: 4,
	},
	text: {
		marginTop: spacing(),
	},
});
